import { SVGProps } from 'react';

export const SpeakersIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M14.243 2.56836H5.75704C3.72017 2.56836 2.06897 4.25279 2.06897 6.33064V14.6681C2.06897 16.746 3.72017 18.4304 5.75704 18.4304H14.243C16.2798 18.4304 17.931 16.746 17.931 14.6681V6.33064C17.931 4.25279 16.2798 2.56836 14.243 2.56836Z'
      strokeWidth='1.26959'
      strokeMiterlimit='10'
    />
    <path
      d='M7.99048 10.1582H15.268'
      strokeWidth='1.26959'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M4.63416 10.1582H5.37123'
      strokeWidth='1.26959'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M12.0003 13.0664H4.63416'
      strokeWidth='1.26959'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M15.268 13.0664H14.5366'
      strokeWidth='1.26959'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
);
